import { BoolFilter, MultiSelectSimpleFilter } from "@dash/filters";

import { DeliveryMethod } from "@megaron/fulfillment-contracts";
import { OrderDisplayFinancialStatus, OrderDisplayFulfillmentStatus } from "@megaron/shopify";

export type OrdersFilterValues = {
  fulfillmentStatus?: string[];
  financialStatus?: string[];
  deliveryMethod?: string[];
  isCancelled?: boolean;
};

type Props = {
  values: OrdersFilterValues;
  onChange: (patch: Partial<OrdersFilterValues>) => void;
  className?: string;
};

const FULFILLMENT_LABELS: Record<string, string> = {
  [OrderDisplayFulfillmentStatus.Fulfilled]: "Zrealizowane",
  [OrderDisplayFulfillmentStatus.PartiallyFulfilled]: "Częściowo zrealizowane",
  [OrderDisplayFulfillmentStatus.Unfulfilled]: "Niezrealizowane",
  [OrderDisplayFulfillmentStatus.InProgress]: "W trakcie",
  [OrderDisplayFulfillmentStatus.OnHold]: "Wstrzymane",
  [OrderDisplayFulfillmentStatus.Restocked]: "Zwrócone do magazynu",
};

const FINANCIAL_LABELS: Record<string, string> = {
  [OrderDisplayFinancialStatus.Paid]: "Opłacone",
  [OrderDisplayFinancialStatus.PartiallyPaid]: "Częściowo opłacone",
  [OrderDisplayFinancialStatus.Pending]: "Oczekujące",
  [OrderDisplayFinancialStatus.Authorized]: "Autoryzowane",
  [OrderDisplayFinancialStatus.Refunded]: "Zwrócone",
  [OrderDisplayFinancialStatus.PartiallyRefunded]: "Częściowo zwrócone",
  [OrderDisplayFinancialStatus.Voided]: "Unieważnione",
  [OrderDisplayFinancialStatus.Expired]: "Wygasłe",
};

const DELIVERY_LABELS: Record<DeliveryMethod, string> = {
  inPostLocker: "Paczkomat InPost",
  inPostCourier: "Kurier InPost",
  shipping: "Wysyłka",
  palletDelivery: "Dostawa paletowa",
  other: "Inne",
};

const FULFILLMENT_VALUES = Object.keys(FULFILLMENT_LABELS);
const FINANCIAL_VALUES = Object.keys(FINANCIAL_LABELS);
const DELIVERY_VALUES = Object.keys(DELIVERY_LABELS) as DeliveryMethod[];

export const fulfillmentOptions = FULFILLMENT_VALUES.map((v) => ({ label: FULFILLMENT_LABELS[v], value: v }));
export const financialOptions = FINANCIAL_VALUES.map((v) => ({ label: FINANCIAL_LABELS[v], value: v }));
export const deliveryMethodOptions = DELIVERY_VALUES.map((v) => ({ label: DELIVERY_LABELS[v], value: v }));

export const nonPalletDeliveryValues: string[] = DELIVERY_VALUES.filter((v) => v !== "palletDelivery");

export const OrdersFilters: React.FC<Props> = ({ values, onChange, className }) => {
  return (
    <div className={className} css={{ display: "flex", gap: "0.5rem", flexWrap: "wrap", alignItems: "center" }}>
      <MultiSelectSimpleFilter
        label="Realizacja"
        values={values.fulfillmentStatus ?? []}
        options={fulfillmentOptions}
        onChange={(v) => onChange({ fulfillmentStatus: v.length ? v : undefined })}
      />
      <MultiSelectSimpleFilter
        label="Płatność"
        values={values.financialStatus ?? []}
        options={financialOptions}
        onChange={(v) => onChange({ financialStatus: v.length ? v : undefined })}
      />
      <MultiSelectSimpleFilter
        label="Dostawa"
        values={values.deliveryMethod ?? []}
        options={deliveryMethodOptions}
        onChange={(v) => onChange({ deliveryMethod: v.length ? v : undefined })}
      />
      <BoolFilter
        label="Anulowane"
        value={values.isCancelled}
        onChange={(v) => onChange({ isCancelled: v })}
        falseLabel="Nie"
        trueLabel="Tak"
      />
    </div>
  );
};
